import React from 'react';
import { Moon } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
export function EmotionalClose() {
  return <section className="py-12 md:py-16 bg-warm-100" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-71">
        <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-8" data-id="element-72">
          Hay dos versiones de vos en 7 días
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-73">
          <div className="bg-warm-200 p-6 rounded-2xl text-left" data-id="element-74">
            <h3 className="font-semibold text-text-muted mb-2" data-id="element-75">La primera</h3>
            <p className="text-text-body text-sm" data-id="element-76">
              Sigue igual: el mismo cansancio, las mismas búsquedas a las 3 AM,
              las mismas peleas.
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-md border border-primary-100 text-left" data-id="element-77">
            <h3 className="font-semibold text-primary-600 mb-2" data-id="element-78">La segunda</h3>
            <p className="text-text-body text-sm" data-id="element-79">
              Se despertó antes que el bebé. Tomó tinto caliente. Sonrió con su
              pareja porque algo cambió.
            </p>
          </div>
        </div>

        <p className="text-xl font-bold text-text-dark mb-2" data-id="element-80">
          Está a <span className="text-primary-600" data-id="element-81">$29.999 COP</span> de
          distancia.
        </p>
        <p className="text-text-muted text-sm mb-6" data-id="element-82">
          Menos que un domicilio para dos.
        </p>

        <div className="flex items-center justify-center gap-2 mb-4 text-primary-500 text-sm font-medium" data-id="element-83">
          <Moon className="w-4 h-4" data-id="element-84" />
          <span data-id="element-85">Un solo paso</span>
        </div>

        <HolographicButton href="https://emalia.lat/cart/48344374509818:1" size="lg" id="btn-compra-cierre" data-id="element-86">
          Comprar ahora
        </HolographicButton>

        <p className="mt-4 text-xs text-text-muted" data-id="element-87">
          Acceso inmediato • Garantía 7 días • 3 bonos incluidos
        </p>
      </div>
    </section>;
}